import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { factTableGetRequest } from "../../../../_redux/_actions";
import { Grid } from "@mui/material";
import {
     ApprovedIcon,
     NotApprovedIcon,
} from "../../../_uiComponents/common/DataGridComponents";

export default function FactTableRowDetails(props) {
     const actionDispatch = useDispatch();

     const { details } = useSelector((state) => {
          return {
               details: state.factTable.details,
          };
     });

     useEffect(() => {
          actionDispatch(factTableGetRequest({ id: props.id }));
     }, []);

     return (
          <>
               <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} lg={4}>
                         <strong>Name :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.name}
                    </Grid>
                    {/* <Grid item xs={12} lg={4}>
                         <strong>Type :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.type}
                    </Grid> */}
                    <Grid item xs={12} lg={4}>
                         <strong>InUse :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.inUse ? <ApprovedIcon/> : <NotApprovedIcon/>}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Total Columns :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.totalColumns}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Total Records :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.totalRecords}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Deleted Records :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.deletedRecords}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Active :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.active ? <ApprovedIcon/> : <NotApprovedIcon/>}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Created By :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.createdBy}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                         <strong>Created On :</strong>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                         {details.createdOn}
                    </Grid>
               </Grid>
          </>
     );
}
